<script setup lang="ts">
definePageMeta({ title: "Jai Kudo" });

const title = "Jai Kudo - Soczewki okularowe Optic Expert";
const description =
    "Jai Kudo to znana marka optyczna, która łączy brytyjskie korzenie z polskim rzemiosłem. Specjalizuje się w produkcji wysokiej jakości soczewek okularowych, łącząc zaawansowane technologie i dbałość o jakość.";
const keywords = "";

const infoSection1 = {
    sectionTitle: {
        title: "Soczewki Fotochromowe",
        paragraph: ""
    },
    sectionImage: {
        src: "/img/products/lenses/jai-kudo/jai-kudo-image-4.webp",
        alt: "Jai Kudo baner reklamowy."
    }
};
</script>
<template>
    <Seo :title="title" :description="description" :keywords="keywords">
        <NuxtLayout name="subpage" hide-background>
            <!-- <section class="pa-4 pa-sm-8 pa-md-16 mx-auto"> -->

            <section class="pa-4 pa-md-10" style="max-width: 1280px; margin: 0 auto">
                <CmsParagraph
                    text="<b>Jai Kudo</b> to znana marka optyczna, która łączy brytyjskie korzenie z polskim rzemiosłem. Specjalizuje się w produkcji wysokiej jakości soczewek okularowych, łącząc zaawansowane technologie i dbałość o jakość."
                />
                <CmsTitle variant="title-1" text="Powłoki antyrefleksyjne JAI KUDO" />
                <CmsParagraph
                    text="Powłoka antyrefleksyjna jest to powłoka, która niweluje refleksy świetlne i odblaski oraz zdecydowanie ułatwiają czyszczenie soczewek okularowych."
                />
                <CmsParagraph
                    text="Zastosowana przez <b>JAI KUDO</b> nowoczesna technologia budowy soczewki okularowej nadaje jej idealnie gładką powierzchnię odporną  na przyleganie brudu, tłuszczu i wody. Zapewnia to wyjątkowy komfort użytkowania okularów. Ponadto, w zależności od wariantu, powłoki  antyrefleksyjne dodatkowo mogą: zwiększać odporność soczewek na zarysowania, chronić wzrok przed światłem UV oraz filtrować światło niebiesko-fioletowe emitowane z ekranów i monitorów."
                />
                <div class="d-flex justify-center">
                    <CmsFloatingImage
                        src="/img/products/lenses/jai-kudo/jai-kudo-image-1.webp"
                        alt="Informacja o produkcie niemedycznym Jai Kudo"
                        block
                        sizes="100vw sm:600px md:1000px"
                        max-width="40rem"
                        width="70%"
                        class="my-3 mx-auto my-4 my-md-8"
                    />
                </div>
                <CmsTitle variant="title-2" class="text-left" text="Powłoki antyrefleksyjne, które oferuje <b>Jai Kudo</b>:" />
                <CmsList variant="unordered-list">
                    <CmsListItem
                        text="<b>StayClean</b> - ograniczenie kłopotliwych odblasków, mniejsze przyleganie brudu, tłuszczu i wody, lepsza przejrzystość i łatwość czyszczenia soczewek."
                    />
                    <CmsListItem
                        text="<b>Clarity</b> - najbardziej zaawansowana powłoka antyrefleksyjna, najwyższa estetyka z minimalnym odbiciem resztkowym, doskonałe właściwości łatwo czyszczące."
                    />
                    <CmsListItem
                        text="<b>Extreme UV</b> - soczewki najbardziej odporne na zarysowania z największą przejrzystością, posiadające warstwy ułatwiające czyszczenie, a także ochronę wzroku przed promieniowaniem UV"
                    />
                    <CmsListItem
                        text="<b>DriveCare</b> - powłoka dedykowana kierowcą, poprawiająca komfort i bezpieczeństwo jazdy głownie nocą i po zmierzchu, lepsza odporność na zarysowania, łatwe czyszczenie."
                    />
                    <CmsListItem
                        text="<b>BlueCare</b> - niezwykle skuteczna ochrona przed zarysowaniami - dodatkowa warstwa utwardzająca, filtrowanie światła niebiesko-fioletowego, ochrona oczu przed szkodliwym promieniowaniem UV, o każdej porze roku, w każdych warunkach."
                    />
                </CmsList>
                <div class="d-flex justify-center">
                    <CmsFloatingImage
                        src="/img/products/lenses/jai-kudo/jai-kudo-image-2.webp"
                        alt="Grafika Jai Kudo 1,5 Blue care"
                        block
                        sizes="100vw sm:600px md:1000px"
                        max-width="40rem"
                        width="70%"
                        class="my-3 mx-auto my-4 my-md-8"
                    />
                </div>
            </section>
            <section class="section-wrapper">
                <div class="pa-4 pa-md-10" style="max-width: 1280px; margin: 0 auto">
                    <CmsTitle variant="title-1" text="Indeksy i Technologie Jai Kudo:" />
                    <CmsList variant="unordered-list">
                        <CmsListItem text="<b>1.50:</b> standardowy indeks, dobry do mniejszych korekcji" />
                        <CmsListItem
                            text="<b>1.59:</b> soczewka jest wykonana z poliwęglanu, co czyni ją bardzo lekką i wyjątkowo odporną na uderzenia , idealne do opraw wierconych oraz dla dzieci,"
                        />
                        <CmsListItem text="<b>1.61:</b>  soczewka cieńsza i lżejsza od indeksu 1.50 o ok. 30%" />
                        <CmsListItem
                            text="<b>1.6 AS:</b> soczewka cieńsza i lżejsza od standardowej o ok. 30%, z asferyczną konstrukcją redukującą powiększenie bądź pomniejszenie oczu przy wyższych mocach,"
                        />
                        <CmsListItem text="<b>1.67:</b> soczewka cieńsza i lżejsza o ok. 40% od standardowego indeksu" />
                        <CmsListItem
                            text="<b>1.67 Aspheric:</b>  cieńsza i lżejsza o ok. 40% z asferyczną konstrukcją redukującą aberracje i powiększenie bądź pomniejszenie oczu przy wyższych mocach,"
                        />
                        <CmsListItem text="<b>1.74:</b>  najcieńsza wersja soczewki dostępna na rynku, soczewki cieńsze o ok. 50% od standardowego indeksu" />
                        <CmsListItem
                            text="<b>1.74 AS:</b>  soczewka cieńsza o ok. 50%, z asferyczną konstrukcją redukującą aberracje i powiększenie bądź pomniejszenie oczu."
                        />
                    </CmsList>

                    <div class="d-flex justify-center">
                        <CmsFloatingImage
                            src="/img/products/lenses/jai-kudo/jai-kudo-image-3.webp"
                            alt="Grafika Jai Kudo porównawcza wymiarów soczewek"
                            block
                            sizes="100vw sm:600px md:1000px"
                            max-width="40rem"
                            width="70%"
                            class="my-3 mx-auto my-4 my-md-8"
                        />
                    </div>
                </div>
            </section>

            <ProductInfoSection
                light
                :title="infoSection1.sectionTitle.title"
                :paragraph="infoSection1.sectionTitle.paragraph"
                :src="infoSection1.sectionImage.src"
                :alt="infoSection1.sectionImage.alt"
            />

            <section class="pa-4 pa-md-10" style="max-width: 1280px; margin: 0 auto">
                <CmsTitle variant="title-2" text="Czym jest Fotochrom?" />
                <CmsParagraph
                    text="Fotochrom (lub okulary fotochromowe) to specjalne soczewki, które automatycznie przyciemniają się na słońcu (pod wpływem promieniowania UV) i wracają do pełnej przezroczystości w pomieszczeniach, oferując komfort widzenia i ochronę oczu, działając jak okulary korekcyjne i przeciwsłoneczne w jednym. Działanie to opiera się na reakcji pigmentów fotochromowych na promieniowanie UV, a ich skuteczność zależy od natężenia światła i temperatury."
                />
                <CmsTitle variant="title-2" text="Jak działają fotochromy:" />
                <CmsList variant="unordered-list">
                    <CmsListItem
                        text="Reakcja na UV: Cząsteczki organiczne w soczewce zmieniają kształt pod wpływem promieniowania ultrafioletowego, co powoduje przyciemnienie szkła."
                    />
                    <CmsListItem text="Zmienność: Im więcej promieniowania UV tym ciemniejsze stają się soczewki." />
                    <CmsListItem
                        text="Powrót do przejrzystości: W pomieszczeniach, bez promieniowania UV, soczewki szybko rozjaśniają się, wracając do stanu przezroczystego."
                    />
                    <CmsListItem
                        text="Wpływ temperatury: Wyższa temperatura spowalnia proces ciemnienia i rozjaśniania, niższa przyspiesza i pogłębia kolor. "
                    />
                </CmsList>
                <CmsTitle variant="title-2" text="Zalety fotochromów:" />
                <CmsList variant="unordered-list">
                    <CmsListItem text="Wszechstronność: Jedna para okularów zastępuje korekcyjne i przeciwsłoneczne." />
                    <CmsListItem text="Ochrona: Chronią oczy przed szkodliwym promieniowaniem UV i nadmiarem światła." />
                    <CmsListItem text="Komfort: Eliminują potrzebę ciągłego zmieniania okularów" />
                </CmsList>

                <CmsParagraph text="<b>Transitions&reg; GEN S&trade;</b>  Blokują 100% promieni <b>UVA i UVB</b>." />
                <CmsParagraph text="Filtrują <b>światło fioletowo-niebieskie</b> zarówno w pomieszczeniach, jak i na zewnątrz:" />
                <CmsParagraph text="Fotochrom <b>Transitions&reg;</b> występuje w ośmiu modnych kolorach:" class="text-center text-primary mt-5" />

                <div class="d-flex justify-center">
                    <CmsFloatingImage
                        src="/img/products/lenses/jai-kudo/jai-kudo-image-5.webp"
                        alt="Grafika Jai Kudo pokazująca osiem kolorów soczewek"
                        block
                        sizes="100vw sm:600px md:800px"
                        max-width="50rem"
                        width="70%"
                        class="my-3 mx-auto my-4 my-md-8"
                    />
                </div>
                <CmsParagraph text="Jai Kudo posiada również w swoim portfolio fotochrom <b>Transitions&reg; XTRActive oraz XTRActive Polarized.</b>" />
                <CmsParagraph
                    dense
                    text="<b>Transitions&reg; XTRActive</b> - Soczewka XTRActive&reg; zapewnia najlepsze zaciemnienie i najlepszą ochronę przed intensywnym światłem, zarówno w pomieszczeniach, jak i na zewnątrz, a nawet za kierownicą."
                />

                <CmsList variant="unordered-list">
                    <CmsListItem text="Najciemniejsze w wysokich temperaturach" />
                    <CmsListItem text="W pomieszczeniach delikatnie zabarwione" />
                    <CmsListItem text="Zabarwiają się w samochodzie" />
                    <CmsListItem text="Dostępne w 3 kolorach (szary, brązowy, szarozielony)" />
                </CmsList>

                <CmsParagraph
                    dense
                    class="mt-5"
                    text="<b>XTRActive&reg; Polarized</b> - Łącząc zalety inteligentnych soczewek fotochromowych i dynamicznej polaryzacji, XTRActive&reg; Polarized zapewnia Twoim oczom ochronę w każdych warunkach oświetleniowych, zapewniając jednocześnie ostrzejsze widzenie, żywe kolory i szerokie pole widzenia na zewnątrz."
                />

                <CmsList variant="unordered-list">
                    <CmsListItem text="Mniejsze odblaski z efektywnością polaryzacji do 90%" />
                    <CmsListItem text="W pomieszczeniach delikatnie zabarwione" />
                    <CmsListItem text="Zabarwiają się w samochodzie" />
                    <CmsListItem text="100% ochronę oczu przed szkodliwym promieniowaniem UV" />
                </CmsList>
            </section>

            <section class="section-wrapper">
                <div class="pa-4 pa-md-10" style="max-width: 1280px; margin: 0 auto">
                    <CmsTitle variant="title-1" class="text-primary text-center" text="Soczewki biurowe:" />

                    <div class="d-flex justify-center">
                        <CmsFloatingImage
                            src="/img/products/lenses/jai-kudo/jai-kudo-image-6.webp"
                            alt="Grafika Jai Kudo soczewki biurowe"
                            block
                            sizes="100vw sm:600px md:800px"
                            max-width="50rem"
                            width="70%"
                            class="my-3 mx-auto my-4 my-md-8"
                        />
                    </div>

                    <CmsParagraph
                        text="<b>Soczewki biurowe</b>  to idealne rozwiązanie dla osób, które spędzają dużo czasu na pracy przy komputerze lub wykonują zadania wymagające wyraźnego widzenia na bliskie i średnie odległości."
                    />
                    <CmsParagraph
                        text="Dzięki zaawansowanej technologii zapewniają komfort widzenia, zmniejszają zmęczenie oczu oraz wspierają prawidłową postawę ciała podczas pracy w pomieszczeniach."
                    />
                    <CmsParagraph text="Rodzaje soczewek biurowych, jakie oferuje <b>Jai Kudo</b>:" />
                    <CmsParagraph
                        text="<b>AdStudio</b> to nowoczesne soczewki, które gwarantują komfortowe widzenie na odległości pośrednie i do bliży. Idealne do pracy, czytania czy korzystania z urządzeń cyfrowych."
                    />
                    <CmsParagraph
                        text="Konstrukcja <b>AdStudio</b> oferujemy trzy warianty zróżnicowane pod względem długości zakresu wyraźnego widzenia dzięki czemu możemy dopasować je do stylu życia i codziennych potrzeb."
                    />

                    <div class="bg-white py-5 mt-5 mt-md-10">
                        <VRow justify="center" align="stretch" no-gutters class="">
                            <VCol cols="4">
                                <Image
                                    sizes="100vw sm:400px md:500px"
                                    crop-fit="contain"
                                    fit="contain"
                                    src="/img/products/lenses/jai-kudo/jai-kudo-info-image-1.webp"
                                    alt="Info gafika"
                                />
                            </VCol>

                            <VCol cols="8">
                                <div class="d-flex flex-column align-start justify-center fill-height pl-0 pl-sm-10 py-10 py-sm-0">
                                    <CmsTitle variant="title-3" text="Wariant nr 1" />
                                    <CmsParagraph
                                        text="To wariant z najszerszym polem pośrednim, którego używamy do patrzenia np. na monitor. Zobaczysz w nich wyraźnie do 1.3 m"
                                    />
                                </div>
                            </VCol>
                            <VCol cols="4">
                                <Image
                                    sizes="100vw sm:400px md:500px"
                                    crop-fit="contain"
                                    fit="contain"
                                    src="/img/products/lenses/jai-kudo/jai-kudo-info-image-2.webp"
                                    alt="Info gafika"
                                />
                            </VCol>

                            <VCol cols="8">
                                <div class="d-flex flex-column align-start justify-center fill-height pl-0 pl-sm-10 py-10 py-sm-0">
                                    <CmsTitle variant="title-3" text="Wariant nr 2" />
                                    <CmsParagraph
                                        text="Równie popularny jak pierwszy, ale bardziej zbalansowany. Szkła oferują trochę węższe pole pośrednie, ale zobaczysz w nich wyraźnie nawet do 2m."
                                    />
                                </div>
                            </VCol>
                            <VCol cols="4">
                                <Image
                                    sizes="100vw sm:400px md:500px"
                                    crop-fit="contain"
                                    fit="contain"
                                    src="/img/products/lenses/jai-kudo/jai-kudo-info-image-3.webp"
                                    alt="Info gafika"
                                />
                            </VCol>

                            <VCol cols="8">
                                <div class="d-flex flex-column align-start justify-center fill-height pl-0 pl-sm-10 py-10 py-sm-0">
                                    <CmsTitle variant="title-3" text="Wariant nr 3" />
                                    <CmsParagraph
                                        text="Wersja rzadziej wybierana, gdyż szerokością pola widzenia, zbliżona jest do szkieł progresywnych. Maksymalny zasięg wyraźnego widzenia to o 4m."
                                    />
                                </div>
                            </VCol>
                        </VRow>
                    </div>
                </div>
            </section>

            <section class="pa-4 pa-md-10" style="max-width: 1280px; margin: 0 auto">
                <CmsTitle variant="title-1" class="text-primary text-center" text="Szkła relaksacyjne ADRELAX" />

                <CmsParagraph
                    text="Szkła relaksacyjne przeznaczone są dla wszystkich osób korzystających na stałe z korekcji okularowej, zwłaszcza tych, które dużo czasu spędzają przed urządzeniami cyfrowymi bądź często przerzucają wzrok z dali do bliży. Różnią się od innych szkieł biurowych JAI KUDO konstrukcją – zapewniają wyraźne widzenie także na dalekie odległości."
                />
                <CmsParagraph
                    text="Ich zadaniem jest wsparcie wzroku podczas patrzenia z bliska, aby zapobiec jego zmęczeniu. Jest to możliwe dlatego, że szkła <b>Readlax</b> mają w dolnej części niewielki dodatek mocy. To ona sprawia, że podczas pracy z bliskiej odległości, oczy wykonują mniejszy wysiłek."
                />
            </section>
            <section class="section-wrapper">
                <div class="pa-4 pa-md-10" style="max-width: 1280px; margin: 0 auto">
                    <CmsTitle variant="title-1" class="text-primary text-center" text="Soczewki Progresywne" />
                    <CmsTitle variant="title-2" class="" text="Czy już czas na okulary progresywne?" />
                    <CmsParagraph
                        text="Pewnie coraz częściej zauważasz, że przesuwasz telefon nieco dalej, aby lepiej zobaczyć tekst, ale litery wciąż wydają się lekko rozmyte. Albo zdarza Ci się patrzeć na coś z daleka i mrużyć oczy, żeby poprawić ostrość?"
                    />
                    <CmsParagraph
                        text="To zupełnie normalne zjawisko – z wiekiem nasze oczy zaczynają działać trochę inaczej, potrzebując więcej wsparcia w dostosowywaniu się do różnych odległości."
                    />

                    <CmsTitle variant="title-2" class="" text="Jedna para okularów na wszystkie odległości" />
                    <CmsParagraph
                        text="Szkła progresywne – genialne rozwiązanie, które pozwala cieszyć się wyraźnym widzeniem zarówno z bliska, jak i z daleka. <b>Wszystko w jednej parze okularów!</b>"
                    />
                    <CmsParagraph
                        text="Dzięki temu nie musisz martwić się o zmianę okularów – różne strefy widzenia płynnie się ze sobą łączą, zapewniając komfort i wygodę każdego dnia. "
                    />
                    <CmsParagraph
                        text="Jeżeli odczuwasz, że Twój wzrok się pogorszył i jednocześnie zależy Ci na dotychczasowym komforcie życia, najwyraźniej nadszedł czas na okulary progresywne."
                    />

                    <CmsTitle variant="title-2" class="" text="Dlaczego zmienia się jakość mojego widzenia?" />
                    <CmsParagraph
                        text="Z wiekiem nasze oczy potrzebują trochę więcej czasu i wysiłku, aby wyostrzyć obraz na różnych odległościach. To zjawisko nazywane jest prezbiopią – jest ono całkowicie naturalne i dotyczy każdego."
                    />
                    <CmsParagraph
                        text="Pojawia się u większości osób po 40. roku życia. Doskonałym rozwiązaniem w takiej sytuacji są okulary progresywne, które umożliwiają wyraźne widzenie zarówno z bliska, jak i z daleka, zapewniając pełen komfort każdego dnia."
                    />
                    <div class="bg-white py-2 my-5 my-md-10">
                        <VRow justify="center" align="stretch" no-gutters class="">
                            <VCol cols="4">
                                <Image
                                    sizes="100vw sm:400px md:500px"
                                    crop-fit="contain"
                                    fit="contain"
                                    src="/img/products/lenses/jai-kudo/jai-kudo-info-image-4.webp"
                                    alt="Info gafika"
                                />
                            </VCol>

                            <VCol cols="8">
                                <div class="d-flex flex-column align-start justify-center fill-height pl-0 pl-sm-10 py-10 py-sm-0">
                                    <CmsTitle variant="title-3" text="Poglądowy rozkład mocy w soczewkach progresywnych:" />
                                    <CmsList variant="ordered-list">
                                        <CmsListItem text="Obszar do dali (4m i dalej)" />
                                        <CmsListItem text="Obszar pośredni (0,5-4m)" />
                                        <CmsListItem text="Obszar do bliży( do 0,5 m)" />
                                        <CmsListItem text="Obszary perfyferyjne" />
                                    </CmsList>
                                </div>
                            </VCol>
                        </VRow>
                    </div>

                    <CmsTitle variant="title-2" class="" text="Wybierz okulary dopasowane do Twoich potrzeb" />
                    <CmsParagraph
                        text="Szkła progresywne <b>HYPERVIEW</b> to soczewki skoncentrowane na potrzebach i wygodzie użytkowników. Zaawansowane technologie, połączone z nieustającym dążeniem do doskonałości sprawiają, że soczewki <b>HYPERVIEW</b> zapewniają wyraźne i ostre widzenie w każdej sytuacji."
                    />
                    <CmsParagraph text="Konstrukcje soczewek progresywnych:" />
                    <CmsList variant="unordered-list">
                        <CmsListItem hide-list-style-image text="<b>S Plus</b> - Optymalne rozwiązanie w korzystnej cenie">
                            <CmsList variant="unordered-list">
                                <CmsListItem text="szerokie pole widzenia" />
                                <CmsListItem text="redukcja bocznych aberracji" />
                                <CmsListItem text="optymalna adaptację" />
                            </CmsList>
                        </CmsListItem>
                        <CmsListItem hide-list-style-image text="<b>Style</b> - Dopasowana do stylu życia">
                            <CmsList variant="unordered-list">
                                <CmsListItem text="indywidualne dopasowanie progresji do preferencji użytkownika" />
                                <CmsListItem text="szerokie i stabilne obszary widzenia" />
                                <CmsListItem text="duża redukcja bocznych zniekształceń" />
                                <CmsListItem text="bardzo łatwa adaptacja" />
                            </CmsList>
                        </CmsListItem>
                        <CmsListItem hide-list-style-image text="<b>Drive</b> - Szkła progresywne dla kierowców">
                            <CmsList variant="unordered-list">
                                <CmsListItem text="bardzo szeroki obszar do dali i odległości pośrednich" />
                                <CmsListItem text="obszar ostrzejszego widzenia po zmierzchu – zwiększona ostrość widzenia" />
                                <CmsListItem text="redukcja uciążliwych refleksów szczególnie po zmroku" />
                            </CmsList>
                        </CmsListItem>
                        <CmsListItem hide-list-style-image text="<b>Identity Lite</b> - Komfort użytkowania na co dzień">
                            <CmsList variant="unordered-list">
                                <CmsListItem text="bardzo szerokie i stabilne obszary widzenia we wszystkich kierunkach" />
                                <CmsListItem text="komfortowe widzenie" />
                                <CmsListItem text="bardzo dobre postrzeganie odległości, kontrastu i głębi" />
                                <CmsListItem text="naturalną, bardzo szybką adaptację" />
                                <CmsListItem text="niwelowanie bocznych zniekształceń" />
                            </CmsList>
                        </CmsListItem>
                        <CmsListItem hide-list-style-image text="<b>Identity Pro</b> - Szerokie pola widzenia dla pełnego komfortu">
                            <CmsList variant="unordered-list">
                                <CmsListItem text="maksymalny komfort przy użyciu najnowocześniejszych technologii" />
                                <CmsListItem text="doskonała ostrość widzenia" />
                                <CmsListItem text="bardzo szybka adaptacja" />
                                <CmsListItem text="zniwelowanie bocznych zniekształceń" />
                                <CmsListItem text="szerokie i stabilne obszary widzenia we wszystkich kierunkach" />
                            </CmsList>
                        </CmsListItem>
                        <CmsListItem hide-list-style-image text="<b>4EVO</b> - nieskończenie płynna ostrość widzenia">
                            <CmsList variant="unordered-list">
                                <CmsListItem text="natychmiastowa adaptacja" />
                                <CmsListItem text="ostre widzenie we wszystkich kierunkach" />
                                <CmsListItem text="maksymalna personalizacja" />
                                <CmsListItem text="płynna ostrość widzenia na każdą odległość" />
                                <CmsListItem text="wyjątkowa wygoda w użytkowaniu od samego początku" />
                            </CmsList>
                        </CmsListItem>
                    </CmsList>
                </div>
            </section>

            <section class="pa-4 pa-md-10" style="max-width: 1280px; margin: 0 auto">
                <CmsTitle variant="title-1" class="text-primary text-center" text="Soczewki dwuogniskowe" />

                <CmsParagraph
                    text="Okulary <b>dwuogniskowe</b> (lub bifokalne) to okulary korekcyjne, zaprojektowane do korygowania wad wzroku jednocześnie w dwóch różnych odległościach – w dali i bliży. W przypadku tych okularów soczewka podzielona jest na dwie strefy: jej dola część jest przeznaczona do czytania, natomiast górna do patrzenia na dal. Oko użytkownika porusza się pomiędzy obydwoma sferami – zależnie od tego, czy kieruje on wzrok w dół (jak przy czytaniu albo pracy na komputerze), czy też wykonuje inne czynności, patrząc na wprost. "
                />
                <CmsParagraph
                    text="Istotną zaletą dwuogniskowych soczewek jest eliminowanie potrzeby posiadania dwóch osobnych par okularów – do czytania i chodzenia (co często ma miejsce w przypadku osób potrzebujących osobnej korekcji do dali i do bliży)."
                />

                <CmsTitle variant="title-2" text="Jak wyglądają okulary dwuogniskowe?" />
                <CmsParagraph
                    text="Okulary dwuogniskowe posiadają dwie strefy o różnych mocach optycznych, które umożliwiają widzenie zarówno w bliży, jak i w dali. Wyróżniają się one tym, że mają charakterystyczną “wtopkę” lub wyraźną linię podziału (mogą przypominać dwa różne szkła “stopione” w jedno)."
                />
                <CmsParagraph
                    text="Nowoczesne technologie optyczne pozwalają obecnie również na produkcję soczewek dwuogniskowych bez widocznej linii podziału, dzięki czemu są one cieńsze i bardziej dyskretne. "
                />

                <CmsTitle variant="title-2" text="Jaki rodzaj szkieł wybrać? Progresywne czy Dwuogiskowe?" />
                <CmsParagraph
                    text="Okulary progresywne są zazwyczaj lepsze ze względu na płynne przejście widzenia na dal, bliż i odległości pośrednie bez widocznej linii, co zapewnia większy komfort, ale są droższe i wymagają adaptacji, podczas gdy dwuogniskowe są tańsze i prostsze, ale mają wyraźną granicę i słabo radzą sobie z odległościami pośrednimi, dlatego wybór zależy od stylu życia, budżetu i preferencji. Progresy to nowoczesny standard, idealny dla osób aktywnych i ceniących estetykę; dwuogniskowe to dobre rozwiązanie budżetowe dla tych, co głównie patrzą w dal i z bliska (np. czytanie) i nie potrzebują pośredniej strefy."
                />
                <CmsParagraph text="Wybierz dwuogniskowe, jeśli:" />
                <CmsParagraph
                    text="Potrzebujesz prostego, ekonomicznego rozwiązania do patrzenia w dal i bliż, nie przeszkadza Ci widoczna linia i rzadko korzystasz z odległości pośrednich lub masz przeciwwskazania do korzystania z soczewek progresywnych."
                />
            </section>
        </NuxtLayout>
    </Seo>
</template>
<style>
.list-enter-active,
.list-leave-active {
    transition: all 0.5s ease;
}
.list-enter-from,
.list-leave-to {
    opacity: 0;
    transform: translateX(1.875rem);
}
</style>
